module.exports = __webpack_public_path__ + "static/media/products.190b0354.png";